(function(){
    angular.module('tmx-app').controller('geotrackingCtrl', ['$mdDialog','menu','$mdSidenav','UsersService','GeoTrackingService','resolvedData','tmxResource','tmxUtility', 
        function GeotrackingCtrl($mdDialog,menu,$mdSidenav,UsersService,GeoTrackingService,resolvedData,tmxResource,tmxUtility) {
            var vm = this;
            vm.positions =[];
            vm.positionsInJson=[];
            vm.directions=[];
            vm.origin;
            vm.destination;
            vm.vm=[];
            vm.container = {};
            vm.events=[];
            vm.vm.UserId=[];
            vm.vm.date=null;
            vm.date=null;
            vm.lookup=[];
            vm.disableUser = true;
            vm.EnableLocation = true;
            vm.menu = menu;

            var makeBDOLOVs = function(BDOs){
                var BDOLovs = [];
                if(BDOs) {
                    for (var i = 0; i < BDOs.length; i++) {
                        BDOLovs.push({
                            "VisibleValue": BDOs[i].UserName,
                            "HiddenValue": BDOs[i].UserID,
                            "RoleId": BDOs.RoleId,
                            "UserTypeLkp": BDOs.UserTypeLkp
                        });
                    }
                }
                return BDOLovs;
            };

            vm.geotrackingGrid = {};
            vm.lookup.users=[];
            vm.lookup.users = makeBDOLOVs(resolvedData.users.Data);
            vm.formatCreatedDate=tmxUtility.formatDateForCompany;

            vm.ShowLocationandUser = function(){


                angular.forEach(JSON.parse(localStorage.getItem("LoggedInUserPrivileges")).roles, function(obj) {
                    if(obj && obj.id == 8 && obj.name == "IT Admin"){
                        vm.disableUser = true;
                        vm.EnableLocation = true;
                    }
                    else{
                        vm.disableUser = false;
                        vm.EnableLocation = false;
                    }

                });
            }
            vm.ShowLocationandUser();

            vm.showpin=[];
            vm.showdescription=[];
            vm.journeyPlans=[]
            vm.event=[];
            vm.device=[];
            vm.time=[];
            vm.date="hello";
            vm.searchData={};
            vm.isDataUnavailable=true;
            vm.gridData1=resolvedData.Locations;
            vm.dataExists=true;
            vm.gridData = new kendo.data.ObservableArray([]);
            vm.loading=false;
            vm.cols=GeoTrackingService.columns;
            vm.service = GeoTrackingService;
            vm.AuditTrialService = tmxResource("AuditTrail");
            vm.showGreenPath = showGreenPath;

        // Grid Configurations
            vm.mainGridOptions = {
                dataSource: {
                    transport: {
                        read: function (o) {
                            vm.searchClear = false;
                            var  d = new Date(vm.vm.date);
                            d=new Date(d.setDate(vm.vm.date.getDate()+1));
                            var mapDate = d.toISOString();
                            var data = {

                                "CreatedDate": mapDate,
                                "UserId": vm.vm.UserId,
                            //"LocationId": vm.vm.LocationId // will update call

                            };
                            var filterStr = ""; // default filters
                            vm.AuditTrialService.getByActionWithParams(o, "GetAuditTrailByUser", true,'put',data, filterStr).then(function (response) {
                                vm.kendoResponse = angular.copy(response);
                                o.success(response);
                                vm.loading=false;

                            });
                            vm.o = angular.copy(o);
                        },
                        dataType: "json"
                    },
                    schema: {
                        data: "data",
                        total: "Total"
                    },
                    serverPaging: true,
                    serverFiltering: true,
                    serverSorting: true,
                //sort: [{field: "SKUStatus", dir: "asec"}, {field: "SKUName", dir: "asec"}]
                },
                pageable: {
                    refresh: true,
                    pageSizes: true,
                    pageSize: 15,
                    buttonCount: 5
                },
                toolbar: ["excel"],
                excel: {
                    allPages: true,
                    fileName: "GeoTracking.xlsx"
                },
                excelExport: function (e) {
                    var sheet = e.workbook.sheets[0];


                    var column = sheet.columns;
                    for(var i=0; i<column.length; i++)
                        column[i].autoWidth = true;


                    for (var rowIndex = 1; rowIndex < sheet.rows.length; rowIndex++) {


                        var row = sheet.rows[rowIndex];
                        row.cells[0].value = vm.formatEventDataItem(row.cells[0].value);

                        row.cells[1].value = vm.formatDataItem(row.cells[1].value);

                        row.cells[2].value = vm.formatDataItem(row.cells[2].value);

                        row.cells[3].value = vm.formatDataItem(row.cells[3].value);


                        row.cells[4].value = vm.formatCreatedDate(row.cells[4].value);


                        row.cells[5].value = vm.formatTime(row.cells[5].value);


                        row.cells[6].value = vm.formatTime(row.cells[6].value);


                        row.cells[7].value = vm.formatDataItem(row.cells[7].value);


                        row.cells[8].value = vm.formatDataItem(row.cells[8].value);


                        row.cells[9].value = vm.formatDataItem(row.cells[9].value);

                    }
                },


                sortable: true,
                scrollable: false,
                rowTemplate: kendo.template($("#rowTemplate").html()),

                columns: GeoTrackingService.columns,
            };

        // Show Geo Tracking Path with PolyLine ??
            function showGreenPath() {

                if (angular.isDefined(vm.hideLogin) && angular.isDefined(vm.hideLogout) && angular.isDefined(vm.hideGeo) && angular.isDefined(vm.hideAppDraft) && angular.isDefined(vm.hideAppSubmit) ) {

                    if (vm.hideLogin && vm.hideLogin && vm.hideGeo && vm.hideAppDraft && vm.hideAppSubmit) {
                        return false;
                    }
                    else if (vm.map.routeMarker.length == 0) {
                        return false;
                    }
                    else {
                        return true;
                    }
                }
            }

        // Date Null Check
            vm.isDateNull=function(){
                return vm.isDataUnavailable;
            }

        // Duplicate Coordinates check generic function
            function cordAlreadyExist(pos,marker){

                for( var i=0;i<marker.length;i++) {
                    if(marker[i].position === pos){
                        return i;
                    }
                }

                return -1;
            }

        // Filter selected Events
            vm.userSelected=function(user){
                vm.vm.UserId=user;
            }
            vm.locationSelected=function(location){

                vm.disableUser = false;
                vm.EnableLocation = true;
                vm.vm.LocationId=location;
                UsersService.getByAction("BDOLovByLocation/"+location, true, 'get').then(function (result) {
                    vm.lookup.users = makeBDOLOVs(result.data);
                });

            }
            vm.dateSelected=function(date){
                vm.vm.date=date;
            }

        // Priority based on Events
            function piority(event){

                if(event == "EVENT_LOAN_APP_SUBMIT" || event == "EVENT_LOAN_APP_DRAFT" || event == "EVENT_LOAN_APP_APPROVED" ){
                    return 3;
                }
                else if (event == "EVENT_GEO_TRACKING" ){
                    return 2;
                }
                else if(event == "EVENT_USER_LOGIN" || event == "EVENT_USER_LOGOUT"){
                    return 1;
                }
                else {
                    return 0;
                }

            }

        // show Event based on checkbox
            function showThisEvent(event){

                if(event == "EVENT_USER_LOGIN" && !vm.hideLogin){
                    return true;
                }
                else if(event == "EVENT_USER_LOGOUT" && !vm.hideLogout){
                    return true;
                }
                else if(event == "EVENT_GEO_TRACKING" && !vm.hideGeo){
                    return true;
                }
                else if((event == "EVENT_LOAN_APP_DRAFT") && !vm.hideAppDraft){
                    return true;
                }
                else if((event == "EVENT_LOAN_APP_SUBMIT") && !vm.hideAppSubmit){
                    return true;
                }
            /*else if((event == "EVENT_LOAN_APP_APPROVED") && !vm.hideAppApproved){
                return true;
            }*/
                else{
                    return false;
                }

            }


        // to be updated yet
            vm.search=function () {

                vm.map={};
                vm.map.routeMarker=[];
                vm.map.directions=[];
                if (!vm.searchForm.$valid) {
                    vm.dataExists=false;
                    return;
                }
                if(vm.vm.date==null) {
                    vm.dataExists=false;
                    return;
                }

                vm.isDataUnavailable=false;

                vm.date=vm.vm.date;
                var  d = new Date(vm.vm.date);
                d = new Date(vm.vm.date);
                d=new Date(d.setDate(vm.vm.date.getDate()+1));
                var mapDate = d.toISOString();


                vm.AuditTrialService.getByAction("GetAuditTrailByUser", true, 'put', {
                    "CreatedDate": mapDate,
                    "UserId": vm.vm.UserId
                }).then(function (result) {

                // IF NO DATA FOUND
                    if(result.data.length==0){
                        vm.dataExists=false;
                        vm.map.routeMarker=[];
                        vm.center="[0,0]";
                        return;
                    }


                    var count=0;
                    var counter=0;
                    var logout=[];

                    for (var i = 0; i < result.data.length; i++) {

                        if(result.Data[i].EventName!=null && !(result.Data[i].EventName ==='EVENT_USER_LOGIN' && result.Data[i].EventName ==='EVENT_USER_LOGOUT') ) {
                        
                            vm.dataExists = true;
                            var event=result.Data[i].EventName;

                            if (showThisEvent(event)) {
                                count++;
                            // console.log(result.data[i]);
                                var positionExist=cordAlreadyExist( "[" + result.Data[i].Latitude + "," + result.Data[i].Longitude + "]",vm.map.routeMarker);
                                // If not a duplicate position
                                if( positionExist === -1) {
                                    vm.map.routeMarker.push({
                                        position: '',
                                        show: false,
                                        Description: [],
                                        img: '',
                                        count: '',
                                        event: '',
                                        zindex:1,
                                        toggle: false
                                    });
                                    vm.map.routeMarker[counter].show = true;
                                    vm.map.routeMarker[counter].position = "[" + result.Data[i].Latitude + "," + result.Data[i].Longitude + "]";
                                    vm.map.routeMarker[counter].event = result.Data[i].EventName;
                                    vm.map.routeMarker[counter].img= vm.getImage(vm.map.routeMarker[counter].event,counter);
                                    vm.map.routeMarker[counter].zindex= vm.getZindex(vm.map.routeMarker[counter].event,counter);


                                    if((event == "EVENT_LOAN_APP_DRAFT" || event == "EVENT_LOAN_APP_SUBMIT" || event == "EVENT_LOAN_APP_APPROVED")) {
                                        vm.map.routeMarker[counter].Description.push({
                                            'EventStartTime': vm.formatTime(result.Data[i].EventStartTime),
                                            'EventEndTime': vm.formatTime(result.Data[i].EventEndTime),
                                            'LoanApplicationNumber': result.Data[i].LoanApplicationNumber,
                                            'EventName': result.Data[i].EventName.split('_').join(" ").replace("EVENT", "") + "  ",
                                            'NationalIdentifierValue':result.Data[i].NationalIdentifierValue+ "  ",
                                            'CustomerName':result.Data[i].CustomerName+ "  ",
                                            'TrasitTime': result.Data[i].TrasitTime
                                        });
                                    }
                                    else if(event == "EVENT_USER_LOGIN" || event == "EVENT_USER_LOGOUT" || event == "EVENT_GEO_TRACKING"){
                                        vm.map.routeMarker[counter].Description.push({
                                            'EventStartTime': vm.formatTime(result.Data[i].EventStartTime),
                                            'EventEndTime': vm.formatTime(result.Data[i].EventEndTime),
                                            'EventName': result.Data[i].EventName.split('_').join(" ").replace("EVENT", "") + "  ",
                                            'TrasitTime': result.Data[i].TrasitTime
                                        });

                                    }
                                    vm.map.routeMarker[counter].count = vm.map.routeMarker[counter].count+count+"";

                                // set Map default Center point
                                    if (counter == 0) {
                                        vm.center = vm.map.routeMarker[counter].position;
                                    }
                                    counter++;
                                    if(event === "EVENT_USER_LOGOUT" ){
                                        logout.push(counter-1);
                                    }
                                }
                                else{       // if duplicate position
                                    if(!piority(vm.map.routeMarker[positionExist].event) >= piority(result.Data[i].EventName)) {
                                        vm.map.routeMarker[positionExist].event=result.Data[i].EventName;
                                    }
                                    vm.map.routeMarker[positionExist].img= vm.getImage(vm.map.routeMarker[positionExist].event,positionExist);
                                    vm.map.routeMarker[positionExist].zindex= vm.getZindex(vm.map.routeMarker[positionExist].event,positionExist);
                                    if((event == "EVENT_LOAN_APP_DRAFT" || event == "EVENT_LOAN_APP_SUBMIT" || event ==="EVENT_LOAN_APP_APPROVED")) {
                                        vm.map.routeMarker[positionExist].Description.push({
                                            'EventStartTime': vm.formatTime(result.Data[i].EventStartTime),
                                            'EventEndTime': vm.formatTime(result.Data[i].EventEndTime),
                                            'LoanApplicationNumber': result.Data[i].LoanApplicationNumber,
                                            'EventName': result.Data[i].EventName.split('_').join(" ").replace("EVENT", "") + "  ",
                                            'NationalIdentifierValue':result.Data[i].NationalIdentifierValue+ "  ",
                                            'CustomerName':result.Data[i].CustomerName+ "  ",
                                            'TrasitTime': result.Data[i].TrasitTime
                                        });
                                    }
                                    else if(event == "EVENT_USER_LOGIN" || event == "EVENT_USER_LOGOUT" || event == "EVENT_GEO_TRACKING"){
                                        vm.map.routeMarker[positionExist].Description.push({
                                            'EventStartTime': vm.formatTime(result.Data[i].EventStartTime),
                                            'EventEndTime': vm.formatTime(result.Data[i].EventEndTime),
                                            'EventName': result.Data[i].EventName.split('_').join(" ").replace("EVENT", "") + "  ",
                                            'TrasitTime': result.Data[i].TrasitTime
                                        });

                                    }

                                    vm.map.routeMarker[positionExist].count = vm.map.routeMarker[positionExist].count+","+count+"";

                                }


                                vm.map.directions.push("["+result.Data[i].Latitude+","+ result.Data[i].Longitude+"]");
                            }


                        }
                    }


                    vm.map.directions = "[" +vm.map.directions.join(",") + "]"
                /*for( var i=0;i<logout.length-1;i++)
                {
                    vm.map.routeMarker.splice(logout[i]-i,1);
                }*/
                });

            // Reload Grid
                if(angular.isDefined(vm.geotrackingGrid.dataSource))
                    vm.geotrackingGrid.dataSource.read();

                if(angular.isDefined(vm.container.brandGrid)) {
                    vm.container.brandGrid.dataSource.read();
                }


            }


        //Dialogs for Markers
            var showInfo = function(Description ,ev) {

                $mdDialog.show({
                    controller: DialogController,
                    template: '<md-dialog style="width:40%;" aria-label="Marker Info">' +
                '<md-toolbar>'+
                '<div class="md-toolbar-tools">'+
                '<h2>{{"Description"|translate}}</h2>'+
                '</div>'+
                '</md-toolbar>'+
                '  <md-dialog-content >' +
                '      <div layout-padding class="padding-left-right-12" ng-repeat="des in Description" layout="column">' +
                '       <div layout="row" flex layout-align="start center"><strong>{{des.EventName}} </strong> </div>' +
                '       <div layout="row" flex layout-align="start center"><strong>Start Time: </strong> {{des.EventStartTime}}</div>' +
                '       <div layout="row" flex layout-align="start center"><strong>End Time: </strong> {{des.EventEndTime}}</div>' +
                '       <div layout="row" flex layout-align="start center"><strong>Transit Time (in min.): </strong> {{des.TrasitTime}}</div>' +
                '    </div>' +
                '  </md-dialog-content>' +
                '  <md-dialog-actions>' +
                '    <md-button ng-click="closeDialog()" class="md-primary">' +
                '      Close' +
                '    </md-button>' +
                '  </md-dialog-actions>' +
                '</md-dialog>',
                    locals: {
                        Description: Description
                    },
                    targetEvent: ev,
                    clickOutsideToClose:true,

                });
            }
            var showLoanInfo= function(Description ,ev) {
                $mdDialog.show({

                    controller: DialogController,
                    template: '<md-dialog style="width:40%;" aria-label="Marker Info">' +
                '<md-toolbar>'+
                '<div class="md-toolbar-tools">'+
                '<h2>{{"Description"|translate}}</h2>'+
                '</div>'+
                '</md-toolbar>'+
                '  <md-dialog-content>' +
                '       <div layout="column" layout-padding class="padding-left-right-12" ng-repeat="des in Description">' +
                '           <div layout="row" flex layout-align="start center"><strong>{{des.EventName}} </strong> </div>' +
                '           <div layout="row" flex layout-align="start center"><strong>Start Time: </strong>{{des.EventStartTime}}</div>' +
                '           <div layout="row" flex layout-align="start center"><strong>End Time: </strong> {{des.EventEndTime}}</div>' +
                '           <div layout="row" flex layout-align="start center"><strong>Transit Time: </strong>{{des.location}}</div>' +
                '           <div layout="row" flex layout-align="start center"><strong>Loan App Num: </strong> {{des.LoanApplicationNumber}}</div>' +
                '           <div layout="row" flex layout-align="start center"><strong>Customer: </strong>{{des.CustomerName}}</div>' +
                '           <div layout="row" flex layout-align="start center"><strong>Customer NIC: </strong> {{des.NationalIdentifierValue}}</div>' +
                '       </div>' +
                '  </md-dialog-content>' +
                '  <md-dialog-actions>' +
                '    <md-button ng-click="closeDialog()" class="md-primary">' +
                '      Close' +
                '    </md-button>' +
                '  </md-dialog-actions>' +
                '</md-dialog>',
                    locals: {
                        Description: Description
                    },
                    targetEvent: ev,
                    clickOutsideToClose:true,

                });
            }
            function DialogController($scope, $mdDialog, Description) {
                $scope.Description = Description;
                $scope.closeDialog = function() {
                    $mdDialog.hide();
                }
            }

        // Toggle Marker functions
            vm.toggleMarkerLoan=function(i,index){
                showLoanInfo(vm.map.journplans[index].Description)
            }
            vm.toggleMarker=function(i,index){
                showInfo(vm.map.routeMarker[index].Description)
            }


            vm.showPin=function(index){
                if(!angular.isDefined(vm.showpin[index]))
                    vm.showpin[index]=true;

                return vm.showpin[index];
            }

            vm.showDescription=function(index){
                if(!angular.isDefined(vm.showdescription[index]))
                    vm.showdescription[index]=false;

                return vm.showdescription[index];
            }

            vm.getPosition=function(index){
                if(vm.showpin[index])
                    return vm.positions[index];
            }


        //get Pins/marker Image based on Event
            vm.getImage=function(event){

                if(event == "EVENT_USER_LOGIN"){
                    return "assets/images/grey.png";
                }
                else if(event=="EVENT_USER_LOGOUT"){
                    return "assets/images/orange.png";
                }
                else if(event=="EVENT_GEO_TRACKING" ){
                    return "assets/images/red.png";
                }
                else if(event=="EVENT_LOAN_APP_DRAFT" ){
                    return "assets/images/yellow.png";
                }
                else if(event=="EVENT_LOAN_APP_SUBMIT" ){
                    return "assets/images/blue.png";
                }
                else if(event=="EVENT_LOAN_APP_APPROVED" ){
                    return "assets/images/green.png";
                }

            }


        // get z index for Event Pin
            vm.getZindex=function(event){

                if(event == "EVENT_LOAN_APP_DRAFT" || event == "EVENT_LOAN_APP_SUBMIT" || event == "EVENT_LOAN_APP_APPROVED"){
                    return 1000;
                }
                else if(event=="EVENT_USER_LOGIN" || event=="EVENT_USER_LOGOUT"){
                    return 100;
                }
                else if(event=="EVENT_GEO_TRACKING" ){
                    return 10;
                }

            }


        //side nav Toggle and is Open
            vm.toggle = function(navID) {
                if(navID != 'SearchSideNav' && vm.isOpen('SearchSideNav')) {
                    $mdSidenav('SearchSideNav')
                        .toggle()
                        .then(function() {
                        });
                }
                else {
                    $mdSidenav(navID)
                        .toggle()
                        .then(function() {
                        });
                }
            };
            vm.isOpen = function(navID) {
                return $mdSidenav(navID).isOpen();
            };


        // Grid data Format Functions
            function leftPad(number) {
                return ((number < 10 && number >= 0) ? '0' : '') + number;
            }
            vm.parseTime=function(s) {
                var c = s.split(':');
                return parseFloat(parseInt(c[0]) * 60 + parseInt(c[1]) + parseFloat((parseInt(c[2])/60)));
            }
            function minutesToStr(minutes) {
                var sign ='';
                if(minutes < 0){
                    sign = '-';
                }

                var hours = leftPad(Math.floor(Math.abs(minutes) / 60));
                minutes = leftPad(Math.abs(minutes) % 60);

                if(minutes.indexOf(".")>0){
                    var seconds=minutes.toString();
                    seconds=seconds.substring(seconds.indexOf("."),seconds.length);
                    seconds=parseInt(parseFloat(seconds)*60);

                    minutes=minutes.substring(0, minutes.indexOf("."));
                    if(seconds*1  < 10) {
                        seconds="0"+seconds;
                    }
                    return sign + hours +':'+minutes + ':' +seconds;
                }

                else return sign + hours +':'+minutes + ':00';

            }
            vm.formatDate=function(date) {
                var d = new Date(date);
                var hh = d.getHours();
                hh-=5;
                var m = d.getMinutes();
                // eslint-disable-next-line no-unused-vars
                var s = d.getSeconds();
                var dd = "AM";
                var h = hh;
                if (h >= 12) {
                    h = hh-12;
                    dd = "PM";
                }
                if (h == 0) {
                    h = 12;
                }
                m = m<10?"0"+m:m;

                s = s<10?"0"+s:s;


                // var pattern = new RegExp("0?"+hh+":"+m+":"+s);

                var replacement = h+":"+m;
                replacement += " "+dd;

                return replacement;
            }
            vm.formatDataItem =function(item){
                if(!angular.isDefined(item) || item==null || item.toString().trim()==""){
                    return 'N/A';
                }
                return item;
            }
            vm.formatEventDataItem =function(item){
                if(!angular.isDefined(item) || item==null || item.toString().trim()==""){
                    return 'N/A';
                }
                return item.split("_").join(" ").replace("EVENT","");
            }

            vm.formatTime =function(item){
                if(!angular.isDefined(item) || item==null){
                    return 'N/A';
                }
                var d = new Date (item);
                return vm.formatAMPM(d);
            //return item.substring(11,19);
            }
            vm.formatAMPM = function(date) {
                var hours = date.getHours();
                var minutes = date.getMinutes();
                var seconds = date.getSeconds();
                var ampm = hours >= 12 ? 'pm' : 'am';
                hours = hours % 12;
                hours = hours ? hours : 12; // the hour '0' should be '12'
                minutes = minutes < 10 ? '0'+minutes : minutes;
                seconds = seconds < 10 ? '0'+seconds : seconds;

                var strTime = hours + ':' + minutes + ':'+ seconds + ' ' + ampm;
                return strTime;
            }
        
            vm.formatTransitTime =function(start,end){
                if(!angular.isDefined(start) || start==null  || !angular.isDefined(end) || end==null){
                    return 'N/A';
                }
                var minutes = vm.parseTime(end.substring(11,19)) - vm.parseTime(start.substring(11,19));
                return minutesToStr(minutes);
            }

        }]);

})();
